export enum CardType {
  Event = 'event',
  Process = 'process',
  Standard = 'standard',
  StandardFavorite = 'standard-favorite',
  Teaser = 'teaser',
  Link = 'link',
  CoreStage = 'core-stage',
  News = 'news',
  Trending = 'trending',
  Resource = 'resource',
  ResourceDownload = 'resource-download',
}
